import { React } from '../libraries'
import { Col, Spinner } from 'react-bootstrap'

export const SpinnerLoading = () => {
  return (
    <Col xs={12} style={{ height: '700px', textAlign: 'center', lineHeight: '550px' }}>
      <Spinner animation='border' role='status'>
        <span className='sr-only'>Loading...</span>
      </Spinner>
    </Col>
  )
}
